"use client";
import {
  Box,
  Flex,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
} from "@chakra-ui/react";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import { BLOCK_STORAGE_DATA, TableFooterConstants } from "./constants";
// import PricingFooter from "./pricingfooter";

const PricingTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();

  return (
    <Box id="pricing">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        Cloud Storage Pricing
      </Heading>
      <Flex direction={{ base: "column", md: "row" }} gap={{ base: 4, md: 10, lg: 20 }}>
        <TableContainer flex={1.5}>
          <Table variant="striped" border={"2px solid rgb(237,242,247)"}>
            <Thead>
              <Tr>
                <Th textAlign={"center"}>Storage</Th>
                <Th textAlign={"center"}>Price (monthly)</Th>
              </Tr>
            </Thead>
            <Tbody>
              {BLOCK_STORAGE_DATA.map((data, index) => {
                return (
                  <Tr key={index} justifyItems={"center"}>
                    <Td justifyItems={"center"}>
                      <Text>{data.storage}</Text>
                    </Td>
                    <Td justifyItems={"center"}>
                      <Text>{data.price}</Text>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
        <Box mt={8} flex={0.75}>
          <Text variant={TextVariant} color="text.100" fontStyle={"italic"}>
            {TableFooterConstants}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default PricingTable;
